import { Phone, MapPin, ExternalLink } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=Ristorante+Baracca+Via+Sant%27Eusebio+12+Biella";
const MAPS_EMBED =
  "https://www.google.com/maps?q=Via%20Sant%27Eusebio%2012%2C%2013900%20Biella%20BI&output=embed";

const Contatti = () => (
  <section id="contatti" className="py-24 lg:py-36 bg-[#F4E8C1]/40">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-8 items-start">
        <div className="lg:col-span-5">
          <Reveal>
            <Eyebrow>Dove siamo & contatti</Eyebrow>
            <h2 className="mt-6 font-serif-display font-medium text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight" data-testid="contatti-title">
              Vi aspettiamo <em className="text-[#7A1C28]">a cena.</em>
            </h2>
            <p className="mt-6 max-w-sm text-base leading-relaxed text-[#6E6A66] font-light">
              Nel centro di Biella, a due passi da tutto. Il tavolo si prenota con una telefonata.
            </p>
          </Reveal>
          <div className="mt-10 space-y-4">
            <Reveal delay={0.1}>
              <a
                href="tel:01521941"
                data-testid="contact-call-button"
                className="group flex items-center justify-between gap-4 border border-[#1C1917]/15 bg-[#FAF8F5] px-6 py-5 hover:border-[#1C1917] transition-colors duration-300"
              >
                <span className="flex items-center gap-4">
                  <Phone size={18} className="text-[#B87F1B]" />
                  <span>
                    <span className="block font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#6E6A66]">Telefono</span>
                    <span className="font-serif-display text-xl">015 21941</span>
                  </span>
                </span>
                <span className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#6E6A66] group-hover:text-[#1C1917] transition-colors">
                  Chiama ora
                </span>
              </a>
            </Reveal>
            <Reveal delay={0.2}>
              <a
                href={MAPS_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="google-maps-link"
                className="group flex items-center justify-between gap-4 border border-[#1C1917]/15 bg-[#FAF8F5] px-6 py-5 hover:border-[#1C1917] transition-colors duration-300"
              >
                <span className="flex items-center gap-4">
                  <MapPin size={18} className="text-[#B87F1B]" />
                  <span>
                    <span className="block font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#6E6A66]">Indirizzo</span>
                    <span className="font-serif-display text-xl">Via Sant'Eusebio, 12 — Biella</span>
                  </span>
                </span>
                <ExternalLink size={16} className="text-[#6E6A66] group-hover:text-[#1C1917] transition-colors" />
              </a>
            </Reveal>
          </div>
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          <Reveal delay={0.15}>
            <div className="frame-clip overflow-hidden border border-[#1C1917]/10 shadow-[0_20px_60px_rgba(28,25,23,0.10)]" data-testid="map-frame">
              <iframe
                title="Mappa di Ristorante Baracca, Via Sant'Eusebio 12, Biella"
                src={MAPS_EMBED}
                className="w-full h-[380px] lg:h-[460px] grayscale-[35%] contrast-[1.05]"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Contatti;
